const type = entry => {
  if (!entry || entry === undefined || entry === null) return

  if (parseInt(entry.price) > 0) return 'Acréscimo'

  return 'Desconto'
}

export default type
